import { render, staticRenderFns } from "./grade-infoOld.vue?vue&type=template&id=cdc62108&scoped=true&lang=pug"
import script from "./grade-infoOld.vue?vue&type=script&lang=js"
export * from "./grade-infoOld.vue?vue&type=script&lang=js"
import style0 from "./grade-infoOld.vue?vue&type=style&index=0&id=cdc62108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc62108",
  null
  
)

export default component.exports